import { Box, Typography, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

import { regularTextColor, titleTextColor } from 'assets/styles/_palette';

interface BoxExtendedProps {
	isAllTextBlack?: boolean;
}

const isAllTextBlackProp = { shouldForwardProp: (prop: string) => prop !== 'isAllTextBlack' };

export const UserStoryTests = styled(
	Box,
	isAllTextBlackProp
)<BoxExtendedProps>(({ isAllTextBlack }) => ({
	...flexMixin({ align: 'flex-start', justify: 'flex-start', direction: 'column', gap: 20 }),
	width: '100%',
	'*': {
		color: isAllTextBlack ? '#000 !important' : 'auto',
	},
}));

export const UserStoryTest = styled(Box)({
	...flexMixin({ align: 'flex-start', direction: 'column', gap: 15 }),
	width: '100%',
});

export const TestPlanTitle = styled(Typography)({
	color: titleTextColor,
	fontSize: '16px',
	fontWeight: 700,
	lineHeight: '133.4%',
	letterSpacing: '0px',
	'& span': {
		fontWeight: 700,
	},
});

export const TestPlanSubTitle = styled(Typography)({
	color: regularTextColor,
	fontSize: '14px',
	fontWeight: 700,
	lineHeight: '157%',
	letterSpacing: '0.1px',
});

export const TestDescription = styled(Typography)({
	color: regularTextColor,
	fontSize: '16px',
	fontWight: 400,
	lineHeight: '150%',
	letterSpacing: '0.15px',
	'& > span': {
		fontWeight: 700,
	},
});

export const TestCaseBox = styled(Box)({
	...flexMixin({ justify: 'flex-start', align: 'flex-start', direction: 'column', gap: 10 }),
});

export const LoaderBox = styled(Box)({
	...flexMixin({}),
	width: '100%',
	height: '100%',
});
